<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol == 'empleado' || rol == 'admin-depto'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container v-else grid-list-xl fluid>
            <v-row>
                <v-col lg="12">
                    <data-table
                        ref="tableComplementos"
                        :tableName="'Complementos'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        :perPage="[10, 25, 50, 100]"
                        @loadModalData="loadModalData"
                        @setFilters="setFilters"
                        :showAdvancedFilters="true">
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar pr-3">
                                <v-btn 
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>
                        <template slot="filters">
                            <v-row>
                                <v-col v-if="rol === 'root'"  cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        :items="clientes"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Cliente"
                                        outlined
                                        v-model="cliente_id"></v-autocomplete>
                                </v-col>
                                <v-col v-if="rol==='root' || rol ==='admin'"  cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        :items="empresas"
                                        item-text="nombre"
                                        item-value="id"
                                        v-model="empresa_id"
                                        label="Empresa"
                                        outlined></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                    <v-autocomplete
                                        :items="cocinas"
                                        item-text="nombre"
                                        item-value="id"
                                        v-model="cocina_id"
                                        label="Cocina"
                                        outlined></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                    <v-text-field
                                        outlined
                                        label="Nombre Complemento"
                                        v-model="nombre_complemento"></v-text-field>
                                </v-col>
                            </v-row>
                        </template>
                        <tbody slot="body" slot-scope="{data}">
                            <tr :key="item.id" v-for="item in data">
                                <td>
                                    <div class="tblPrincipal">{{ item.nombre }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.descripcion }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">
                                        <div v-for="c in item.cocinas" :key="c.id">
                                            {{ c.nombre }}
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{on}">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="abrirModal('update',item)">
                                                        <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{on}">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="removeComplemento(item)">
                                                        <v-icon class="tamIconoBoton invertirColorBotones">delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>
        <template>
            <v-dialog v-model="modal" persistent max-width="700px" scrollable>
                <template v-slot:activator="{on}">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>
                <perfect-scrollbar style="background: #FFF;">
                    <v-card elevation="0">
                        <ValidationObserver ref="form" v-slot="{invalid}">
                            <v-card-title class="card_titulo">
                                <div class="headerModal">
                                    <!-- <img :src="imagen" alt="imgModal">
                                    <h2 class="titleModal">{{ titulo_modal }}</h2> -->
                                    <h2 class="ml-4 mb-10">{{ titulo_modal }}</h2>
                                </div>
                            </v-card-title>
                            <v-card-text class="card_texto">
                                <v-container grid-list-md id="contenedor" >
                                    <template v-if="accion === 'add'">
                                        <v-row>
                                            <v-col v-if="rol === 'root'" cols="12" xs="12" md="12" lg="12" xl="12" class="py-0">
                                                <ValidationProvider v-slot="{errors}" name="Cliente" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        label="Cliente"
                                                        :items="clientes"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        v-model="cliente_id"
                                                        required
                                                        :error-messages="errors">
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col v-if="rol === 'root' || rol === 'admin'"  cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                                <ValidationProvider v-slot="{errors}" name="Empresa" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        label="Empresa"
                                                        :items="empresas"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        v-model="empresa_id"
                                                        required
                                                        :error-messages="errors">
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                                <multiple-autocomplete
                                                    outlined
                                                    :items="cocinas"
                                                    :valorDefecto="cocinas_seleccionadas"
                                                    item_text="nombre"
                                                    @dataMultiple="(data)=> cocinas_seleccionadas = data"
                                                    label="Cocinas"
                                                    ref="multCocina"></multiple-autocomplete>
                                            </v-col>
                                            <v-col cols="12" xs="12" md="5" lg="5" xl="5" class="py-0">
                                                <v-text-field
                                                    outlined
                                                    label="Nombre complemento"
                                                    v-model="complemento.nombre"
                                                    >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" xs="12" md="5" lg="5" xl="5" class="py-0">
                                                <v-text-field
                                                    outlined
                                                    label="Descripcion"
                                                    v-model="complemento.descripcion"
                                                    >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2" class=" pb-0 pt-0 ma-0 d-flex  justify-center aling-center">
                                                <v-btn color="#1E2245" class="mt-2 d-flex justify-center align-center"  elevation="0" dark fab @click="agregarComplemento()" small>
                                                    <v-icon dark>add</v-icon>
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                <table class="tbl-modal">
                                                    <thead class="tbl-header-modal">
                                                        <tr>
                                                            <th class="pl-7 firstth">Nombre complemento</th>
                                                            <th>Descripción</th>
                                                            <th class="lastth text-center">Opciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-if="complementos.length == 0">
                                                            <td class="emptyTableModal" colspan="11">
                                                                No hay elementos para mostrar
                                                            </td>
                                                        </tr>
                                                        <template v-else v-for="(itemC, index) in complementos">
                                                            <tr :key="index">
                                                                <td class="pl-5">
                                                                    <v-text-field
                                                                        outlined
                                                                        label=""
                                                                        class="pa-0 ma-0"
                                                                        v-model="itemC.nombre"
                                                                        dense
                                                                        hideDetails></v-text-field>
                                                                </td>
                                                                <td class="pr-5 py-2">
                                                                    <v-text-field
                                                                        outlined
                                                                        label=""
                                                                        class="pa-0 ma-0"
                                                                        v-model="itemC.descripcion"
                                                                        dense
                                                                        hideDetails></v-text-field>
                                                                </td>
                                                                <td class="text-center">
                                                                    <v-btn class="botonHover" icon fab dark small @click="eliminarComplemento(index)">
                                                                        <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                                    </v-btn>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <template v-else-if="accion === 'update'">
                                        <v-row>
                                            <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                                <ValidationProvider v-slot="{errors}" name="Nombre" rules="required">
                                                    <v-text-field
                                                        outlined
                                                        label="Nombre complemento"
                                                        v-model="complemento.nombre"
                                                        required
                                                        :error-messages="errors">
                                                    </v-text-field>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                                <ValidationProvider v-slot="{errors}" name="Descripcion" rules="required">
                                                    <v-text-field
                                                        outlined
                                                        label="Descripción"
                                                        v-model="complemento.descripcion"
                                                        required
                                                        :error-messages="errors">
                                                    </v-text-field>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                <table class="tbl-modal">
                                                    <thead class="tbl-header-modal">
                                                        <tr>
                                                            <th class=" firstth">Nombre cocina</th>
                                                            <th>Descripción</th>
                                                            <th class="lastth text-center">Opciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                            <tr :key="cocina.id" v-for="cocina in cocinasComplemento ">
                                                                <td class="pl-4">
                                                                    <span>{{ cocina.nombre }}</span>
                                                                </td>
                                                                <td class="px-4 py-2">
                                                                    <span>{{ cocina.descripcion }}</span>
                                                                </td>
                                                                <td class="text-center">
                                                                    <v-btn class="botonHover" icon fab dark small @click="eliminarCocina(cocina.id)">
                                                                        <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                                    </v-btn>
                                                                </td>
                                                            </tr>
                                                    </tbody>
                                                </table>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-end card_accion">
                                <v-btn class="btnCerrar elevation-0" @click="cerrarModal()" :disabled="loading_guardar">Cancelar</v-btn>
                                <v-btn class="btnGuardar elevation-0" @click="guardar()" :loading="loading_guardar">Guardar</v-btn>
                            </v-card-actions>
                        </ValidationObserver>
                    </v-card>
                </perfect-scrollbar>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Datatable from '@/components/datatable/Datatable'
import VuetifyMultipleAutocomplete2 from '@/components/VuetifyMultipleAutocomplete2'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import PerfectScrollbar from 'perfect-scrollbar'
import clientesApi from '@/api/clientes'
import empresasApi from '@/api/empresas'
import cocinasApi from '@/api/cocinas'
import complementosApi from '@/api/complementos'
import Notify from '@/plugins/notify'

    export default {
        components:{
            'data-table':Datatable,
            'multiple-autocomplete':VuetifyMultipleAutocomplete2,
            ValidationObserver,
            ValidationProvider
        },
        data(){
            return{
                url:'comida-complemento/find',
                columns:[
                    {
                        label:'Nombre',
                        name:'nombre',
                        filterable:false
                    },
                    {
                        label:'Descripcion',
                        name:'descripcion',
                        filterable:false
                    },
                    {
                        label:'Cocinas',
                        name:'cocinas',
                        filterable:false
                    },
                    {
                        label:'Opciones',
                        name:'opciones',
                        filterable:false,
                        align:'center'
                    }
                ], 
                filters:{
                    activo:true,
                    paginate:true,
                    order_by:'nombre',
                    empresa_id:null,
                    cliente_id:null,
                    sucursal_id:null,
                    cocina_id:null,
                    nombre:''
                },
                complemento:{
                    nombre:'',
                    descripcion:''
                },
                titulo_modal:'',
                imagen:'',
                modal:false,
                cliente_id:null,
                empresa_id:null,
                sucursal_id:null,
                cocina_id:null,
                nombre_complemento:'',
                accion:'',
                clientes:[],
                empresas:[],
                cocinas:[],
                cocinasComplemento:[],
                cocinas_seleccionadas:[],
                complementos:[],
                datosLogin:'',  
                loading_guardar:false,
                rol:'',
                params:{activo:true,paginate:false,order:'asc'}

            }
        },
        watch:{
            cliente_id:function(newVal){
                if(newVal != null){
                    this.getEmpresas(newVal)
                }
            },
            empresa_id:function(newVal){
                if(newVal != null && this.rol != 'admin-sucursal'){
                    this.getCocinas(newVal)
                }
            }
        },
        methods:{
            listar(){
                this.datosLogin = this.$session.get('usuario')
                this.rol = this.datosLogin.rol.name

                if(this.rol == 'admin'){
                    this.cliente_id = this.datosLogin.cliente_id
                    this.filters.cliente_id = this.datosLogin.cliente_id
                }else if(this.rol == 'admin-empresa'){
                    this.cliente_id = this.datosLogin.cliente_id
                    this.empresa_id = this.datosLogin.empresa_id
                    this.filters.empresa_id = this.datosLogin.empresa_id
                    
                }else if(this.rol == 'admin-sucursal'){
                    this.cliente_id = this.datosLogin.cliente_id
                    this.empresa_id = this.datosLogin.empresa_id
                    this.sucursal_id = this.datosLogin.sucursal_id
                    this.filters.cliente_id = this.datosLogin.cliente_id
                    this.filters.empresa_id = this.datosLogin.empresa_id
                    this.filters.sucursal_id = this.datosLogin.sucursal_id               
                }
            },
            async loadModalData(){
                await this.reset()

                if(this.rol == 'root'){
                    this.getClientes()
                }else if(this.rol == 'admin'){
                    this.getEmpresas(this.cliente_id)
                }else if(this.rol == 'admin-empresa'){
                    this.getCocinas(this.empresa_id)
                }else if(this.rol == 'admin-sucursal'){
                    this.getCocinas(this.sucursal_id)
                }

            },
            setFilters(){

                this.filters.cliente_id = this.cliente_id
                this.filters.empresa_id = this.empresa_id
                this.filters.cocina_id = this.cocina_id
                this.filters.nombre = this.nombre_complemento

                this.$refs.tableComplementos.getData()

            },
            async abrirModal(accion,item = null){
                this.errors.clear()
                this.reset()
                this.modal = true 
                this.accion = accion

                //load data
                await this.loadModalData()

                if(accion == 'add'){
                    this.titulo_modal = 'Registrar complementos'
                    this.imagen = '/static/modal/clienteCreate.svg'
                }else if(accion == 'update'){
                    this.titulo_modal = 'Actualizar complemento'
                    this.imagen ='/static/modal/clienteUpdate.svg'

                    this.complemento.id = item.id
                    this.complemento.nombre = item.nombre
                    this.complemento.descripcion = item.descripcion
                    this.cocinasComplemento = item.cocinas
                    //console.log(this.cocinasComplemento);
                }

            },
            agregarComplemento(){

                if(this.complemento.nombre == ''){
                    Notify.ErrorToast("Ingrese al menos un nombre para el complemento")
                }else{
                    this.complementos.push({...this.complemento})
                    this.complemento = {
                        nombre: '',
                        descripcion: ''
                    }
                    
                }
                
            },
            eliminarComplemento(index){
                this.complementos.splice(index,1)    
            },
           async  eliminarCocina(id){
            //elimina la cocina seleccionada en el modal de editar
            
                let cocinasArr = []
                cocinasArr.push(this.cocinasComplemento.find(el => el.id === id))
                //console.log(typeof cocinasArr);
                let parametros = {
                    complemento_id: this.complemento.id,
                    cocinas:await cocinasArr.map(item =>{
                        return item.id
                    })
                }
                
                //console.log(parametros);
                Notify. Alert(
                    "ADVERTENCIA",
                    "¿Estás seguro que deseas eliminar el complemento de la cocina actual?",
                    "Eliminar",
                    ()=>{
                        complementosApi.deleteComplemento(parametros).then(resp =>{
                            Notify.Success("Operación exitosa","El complemento se eliminó satisfactoriamente")
                            this.$refs.tableComplementos.getData()
                            this.cerrarModal()
                        }).catch(err =>{
                            this.loading_guardar = false
                            if(typeof err.response.data.error === 'string'){
                                Notify.ErrorToast(err.response.data.error)
                            }else{
                                let error = Object.values(err.response.data.error)
                                let leyenda = ``

                                for (var i = 0; i < error.length; i++){
                                    leyenda += `*` + error[i] + `\n`
                                }

                                Notify.ErrorToast(leyenda)
                            }
                        })
                    })

            },
            async removeComplemento(item){
              
                let params ={
                    cocinas: await item.cocinas.map(item =>{
                        return item.id
                    }),
                    complemento_id: item.id
                }

               // console.log(params);
               Notify. Alert(
                    "ADVERTENCIA",
                    "¿Estás seguro que deseas eliminar el complemento actual?",
                    "Eliminar",
                    ()=>{
                        complementosApi.deleteComplemento(params).then(resp =>{
                            Notify.Success("Operación exitosa","El complemento se eliminó satisfactoriamente")
                            this.$refs.tableComplementos.getData()
                        }).catch(err =>{
                            this.loading_guardar = false
                            if(typeof err.response.data.error === 'string'){
                                Notify.ErrorToast(err.response.data.error)
                            }else{
                                let error = Object.values(err.response.data.error)
                                let leyenda = ``

                                for (var i = 0; i < error.length; i++){
                                    leyenda += `*` + error[i] + `\n`
                                }

                                Notify.ErrorToast(leyenda)
                            }
                        })
                    })
            },
            guardar(){

                this.$refs.form.validate().then(result =>{
                    if(result){
                        this.loading_guardar = true

                        if(this.accion === 'add'){

                            let data = {
                                arrComplementos:[],
                                arrCocinas:[]
                            }
    
                            let arrC = this.cocinas.filter(el => this.cocinas_seleccionadas.includes(el.id))
    
                            arrC.forEach(element => {
                                let tmp = new Object()
                                tmp.id = element['id']
                                tmp.nombre = element['nombre']
                                data.arrCocinas.push(tmp)
                            });

                            //data.arrComplementos = this.complementos

                            if(this.complementos.length == 0){
                                Notify.ErrorToast("Agregar al menos un complemento a la tabla.");
                                this.loading_guardar = false
                                return
                            }else if(this.complementos.length > 0){
                                data.arrComplementos = this.complementos
                            }

                            complementosApi.addComplementos({cocinas:data.arrCocinas,complementos:data.arrComplementos}).then(resp =>{
                                this.$refs.tableComplementos.getData()
                                Notify.Success("Operación exitosa","Los complementos se guardaron satisfactoriamente")
                                this.cerrarModal()
                            }).catch(err =>{
                                this.loading_guardar = false
                                if(typeof err.response.data.error === 'string'){
                                    Notify.ErrorToast(err.response.data.error)
                                }else{
                                    let error = Object.values(err.response.data.error)
                                    let leyenda = ``

                                    for (var i = 0; i < error.length; i++){
                                        leyenda += `*` + error[i] + `\n`
                                    }

                                    Notify.ErrorToast(leyenda)
                                }
                            })

                        }else{
                            complementosApi.updateComplemento(this.complemento).then(resp =>{
                                this.$refs.tableComplementos.getData()
                                Notify.Success("Operación exitosa","El complemento se actualizó satisfactoriamente")
                                this.cerrarModal()
                            }).catch(err =>{
                                this.loading_guardar = false
                                if(typeof err.response.data.error === 'string'){
                                    Notify.ErrorToast(err.response.data.error)
                                }else{
                                    let error = Object.values(err.response.data.error)
                                    let leyenda = ``

                                    for (var i = 0; i < error.length; i++){
                                        leyenda += `*` + error[i] + `\n`
                                    }

                                    Notify.ErrorToast(leyenda)
                                }
                            })
                        }
                    }
                })

            },
            cerrarModal(){
                this.modal = false
                this.reset()
            },
            async reset(){
                
                this.complemento = {
                    nombre:'',
                    descripcion:''
                }
                this.titulo_modal = ''
                this.imagen = ''
                this.clientes = []
                this.empresas = []
                this.cocinas = []
                this.cocinas_seleccionadas = []
                this.complementos = []
                this.loading_guardar = false
                if(this.rol == 'root'){
                    this.cliente_id = null
                    this.empresa_id = null
                }
                if(this.rol == 'admin'){
                    this.empresa_id = null
                }
                this.cocina_id = null
                this.nombre_complemento = ''

                this.$nextTick(()=>{
                    if(this.$refs.form){
                        this.$refs.form.reset()
                    }
                })
            },
            getClientes(){
                clientesApi.getClientes(this.params).then(resp =>{
                    //console.log(resp.data);
                    this.clientes = resp.data
                }).catch(err =>{
                    console.log('ocurrio un error al cargar los clientes',err);
                })
            },
            getEmpresas(id){
                let params = {...this.params, cliente_id:id}
                //console.log(params);
                empresasApi.getEmpresas(params).then(resp=>{
                    this.empresas = resp.data
                    //console.log(resp.data);
                }).catch(err =>{
                    console.log('Ocurrio un error al cargar las empresas', err);
                })
            },
            getCocinas(id){
                let params = {...this.params,cliente_id:this.cliente_id,empresa_id:id}
                if(this.rol == 'admin-sucursal'){
                    params = {...this.params,cliente_id:this.cliente_id,empresa_id:this.empresa_id,sucursal_id:id}
                }
                cocinasApi.getCocinas(params).then(resp =>{
                    //console.log(resp.data);
                    this.cocinas = resp.data
                }).catch(err =>{
                    console.log('Ocurrio un error al cargar las cocinas',err);
                })
            },
            redireccionar(){
                this.$router.push('/dashboard');
            },
        },
        created(){
            this.listar()
        }
    }
</script>

<style scoped>
h2{
    font-family: 'Montserrat';
    font-size: 18px;
    font-weight: 600;
    line-height: 21.94px;
}
th{
        color:#828282;
        font-family: 'Montserrat';
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 17px;
        text-align: left;
        padding: 17px 12px 17px  12px;
    }

    .tbl-modal tbody td{
        color: #1E2144;
        font-family: 'Montserrat';
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 17px;
        padding: 2px;
        text-align: left;
    }

    .tbl-modal {
        border-collapse: collapse;
        width: 100%;
        margin-top: 15px;
        overflow-x: scroll;
        overflow-y: scroll;
    }

    .tbl-modal .tbl-header-modal {
        background: #F6F6F6;
        border-radius: 10px;
        height: 58px;
    }
    .firstth {
        border-top-left-radius: 20px !important;
        padding: 17px 12px 17px  12px;
    }
    .lastth {
        border-top-right-radius: 20px !important;
        padding: 17px 12px 17px  12px;
    }
    .emptyTableModal{
        color: #c5c5c5 !important;
        font-family: "Montserrat" !important;
        font-size: 12px !important;
        font-style: normal !important;
        font-weight: 500 !important;
        line-height: 22px !important;
        padding-bottom: 50px !important;
        padding-top: 50px !important;
        text-align: center !important;
    }
</style>